import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { connect } from 'react-redux';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import ActionsMenu from 'components/actions_menu';
import ClickableIcon from 'components/clickable_icon';
import confirm from 'components/confirm';
import PhotoOrInitials from 'components/photo_or_initials';
import TaggedBody from 'bundles/apex/deals/tagged_body';
import { formatDate, TIME_FORMAT } from 'helpers/formatters/date_time_formats';

export function DealComment({ comment, forUser, today, onDelete, onEdit }) {
  const { createdAt, updatedAt, user } = comment;

  let createdAtString = formatDate(createdAt, TIME_FORMAT);
  if (!today) {
    createdAtString = `${formatDate(createdAt, 'MMM D')}, ${createdAtString}`;
  }

  const updatedAtString = formatDate(updatedAt, `MMM D, ${TIME_FORMAT}`);

  const deleteComment = () => {
    confirm('Are you sure you want to delete this comment?', {
      buttonLabel: 'Delete',
      buttonStyle: 'danger',
      title: `Delete Comment?`
    }).then(async () => {
      onDelete(comment);
    });
  };

  const isForUser = user.id == forUser.id;

  return (
    <div className={classNames('deal-comment', { 'current-user': isForUser })}>
      <div className={`deal-comment-icons ${isForUser ? 'ml-2' : 'mr-2'}`}>
        <PhotoOrInitials user={user} />
        {isForUser &&
          <div className="deal-comment-actions-menu">
            <ActionsMenu
              className="photo-or-initials initials"
              icon={<ClickableIcon icon={faEllipsisV}/>}
              id={comment.id}
              onDelete={deleteComment}
              onShowModal={onEdit}
            />
          </div>}
      </div>
      <div className="deal-comment-main">
        <div className="deal-comment-info mb-1">
          <div className="deal-comment-name mx-2">{user.name}</div>
          <div className="deal-comment-timestamp">{createdAtString}</div>
        </div>
        <div className="deal-comment-body-container">
          <div className="deal-comment-body">
            <TaggedBody bodyParts={comment.bodyParts} />
          </div>
          {comment.createdAt !== updatedAt && <div className="deal-comment-edited">(edited {updatedAtString})</div>}
        </div>
      </div>
    </div>
  );
}

DealComment.propTypes = {
  comment: PropTypes.shape({
    bodyParts: PropTypes.array,
    createdAt: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired
  }),
  forUser: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  today: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

const mapStateToProps = ({ forUser }) => ({
  forUser
});

export default connect(mapStateToProps)(DealComment);
